import React from 'react';
import './style.css';
import { useParams } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';

import SmartControlTags from './SmartControlTags';
import SmartMotorControl from './SmartMotorControl';
import SmartLightControl from './SmartLightingControl';

const SmartControl = (props) => {
  const [formType, setFormType] = useState('');
  const hookParams = useParams();

  useEffect(() => {
    console.log(props);

    if (hookParams.formName) {
      setFormType(hookParams.formName);
    }
    document.title = 'Rubus-Smart Control Form';
  }, [hookParams.formName]);

  return (
    <Fragment>
      {formType === 'VibrationDashboard' && <SmartMotorControl />}
      {formType === 'SmartLightControl' && <SmartLightControl />}
      {formType === 'SmartControlTag' && <SmartControlTags />}
    </Fragment>
  );
};

export default SmartControl;
